<template>
   <v-container fluid fill-height>
      <v-layout>
         <v-flex xs12 sm12 md12>
            <v-card class="rounded-lg">
               <v-toolbar color="#f8f9fb" elevation="0">
                  <v-toolbar-title>House Member</v-toolbar-title>
               </v-toolbar>
               <v-divider></v-divider>
               <v-card-text class="pa-10">
                  <v-form>
                     <v-row>
                        <v-col cols="12" x  s="12" sm="12" md="6">
                          <v-radio-group v-model="selected_type" row>
                            <v-radio
                              v-for="type in types"
                              :key="type.field"
                              :label="type.label"
                              :value="type.field"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                     </v-row>
                     <v-row v-if="selected_type=='flat'">
                        <v-col  cols="12" xs="12" sm="12" md="6">
                            <v-select
                              title="flat"
                              name="flat"
                              label="Flat"
                              :items="flats"
                              item-text="name"
                              item-value="id"
                             >      
                            </v-select>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                          <v-radio-group v-model="home_type" row>
                            <v-radio
                              v-for="type in home_types"
                              :key="type.field"
                              :label="type.label"
                              :value="type.field"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="house.house_no"
                              name="house_no"
                              label="House No"
                              v-validate="'required'"
                              :error="
                              errors.first('house_no') != null ||
                              serverSideErrors.house_no != null
                              "
                              :error-messages="
                              errors.first('house_no') || serverSideErrors.house_no
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="house.person_name"
                              name="person_name"
                              label="Person Name"
                              v-validate="'required'"
                              :error="
                              errors.first('person_name') != null ||
                              serverSideErrors.person_name != null
                              "
                              :error-messages="
                              errors.first('person_name') || serverSideErrors.person_name
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6">
                           <v-text-field
                              v-model="house.contact_no"
                              name="contact_no"
                              label="Contact No"
                              v-validate="'required'"
                              :error="
                              errors.first('contact_no') != null ||
                              serverSideErrors.contact_no != null
                              "
                              :error-messages="
                              errors.first('contact_no') || serverSideErrors.contact_no
                              "
                              ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-form>
               </v-card-text>
               <v-card-actions class="pb-5">
                  <v-btn color="secondary" dark class="px-8 ml-2" @click="saveHouseDetail" :loading="loading">Save</v-btn>
               </v-card-actions>
            </v-card>
         </v-flex>
      </v-layout>
   </v-container>
</template>
<script>
   import { mapMutations } from 'vuex';
   export default {
     data() {
       return {
         types : [
          {
            label : 'Flat',
            field : 'flat'
          },
          {
            label : 'Single house',
            field : 'single_house'
          },
          {
            label : 'Shop',
            field : 'shop'
          },
         ],
          home_types : [
          {
            label : 'Owner',
            field : 'owner'
          },
          {
            label : 'Tenant',
            field : 'tenant'
          },
           ],
         user: {},
         loading: false,
         house: {
           house_no: '',
           person_name: '',
           contact_no: '',
         },
         serverSideErrors: {},
         flats: [],
         selected_type : 'flat',
         home_type: 'owner',
         
       };
     },
    //  watch : {
    //    selected_type(){
    //      this.getSubData(this.selected_type)
    //    }
    //  },
     methods:{
       ...mapMutations('alert',['setAlert']),
      //   getSubData(selected_type){
      //    console.log(selected_type);
        
      //  }, 
        saveHouseDetail() {
         let _self = this;
         this.$validator.validateAll().then((result) => {
           if (result) {
             _self.loading = true;
             let formData = new FormData();
             formData.append('house_no',this.house.house_no);
             formData.append('house_no',this.house.house_no);
             formData.append('person_name',this.house.person_name);
             formData.append('contact_no',this.house.contact_no);
             console.log(formData);
             _self.$axios.post('/superadmin/saveHouseDetail',formData,
             {
               headers: {
                 'Content-Type':'multipart/form-data'
               }
             })
             .then( response => {
               let data = response.data;
   
               _self.loading = false;
               _self.serverSideErrors = {};
   
               if(data.status) {
                 this.setAlert({
                   showAlert : true,
                   message : data.message,
                   variant : 'green accent-4',
                   timeout : 2000
                 });
               } else {
                 if(!data.errors) {
                   this.setAlert({
                     showAlert : true,
                     message : data.message,
                     variant : 'red accent-3',
                     timeout : 2000
                   });
                 } else {
                   for(let i=0 ; i<data.errors.length ; i++) {
                     this.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                   }
                 }
               }
             })
           }
         });
       },
     getFlat() {
      let _self = this;
      _self.$axios
        .get("societyadmin/flat?society_id=" + _self.user.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.flats = data.flat;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
     },
     getHouseDetail(){
        let _self = this;
      _self.$axios
        .get("societyadmin/house/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.house = data.house;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
     }
     },
     mounted() {
       this.user = JSON.parse(localStorage.getItem("user"));
       this.getHouseDetail();
     },
   };
</script>
<style scoped>
   .font-30 {
   font-size: 30px !important;
   }
   /* make the icon clickable in badge slot */
   .edit-icon { 
   z-index: 1000;
   }
</style>